import { SvgIconType } from './svg.interface';

const Edit: SvgIconType = ({
  width = 12,
  height = 12,
  className = '',
  color = '#4F566B',
  onClick
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3952 3.20951L8.79049 0.604834L8.85588 0.539445C9.57514 -0.179815 10.7413 -0.179815 11.4606 0.539445C12.1798 1.25871 12.1798 2.42486 11.4606 3.14412L11.3952 3.20951ZM10.3345 4.27017L3.38607 11.2186L0 12L0.781401 8.61393L7.72983 1.66549L10.3345 4.27017Z"
      fill={color}
    />
  </svg>
);

export default Edit;
